/**
 * <ScribbleSelect>: hand-drawn select/dropdown.
 *
 * M2.T11 per IMPLEMENTATION_PLAN §7 M2.T11.
 *
 * A styled native <select> with a custom SVG dropdown indicator.
 */

type SelectOption = {
  value: string;
  label: string;
};

type ScribbleSelectProps = {
  value: string;
  onChange: (v: string) => void;
  options: SelectOption[];
  label?: string;
  id?: string;
  disabled?: boolean;
};

export function ScribbleSelect({
  value,
  onChange,
  options,
  label,
  id,
  disabled = false,
}: ScribbleSelectProps) {
  const selectId = id ?? "scribble-select";
  return (
    <div class="scribble-select-wrapper">
      {label && (
        <label class="scribble-select-label" for={selectId}>
          {label}
        </label>
      )}
      <div class="scribble-select-inner">
        <select
          id={selectId}
          class="scribble-select"
          value={value}
          disabled={disabled}
          onChange={(e) => onChange((e.target as HTMLSelectElement).value)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {/* Hand-drawn chevron indicator */}
        <svg
          class="scribble-select-chevron"
          viewBox="0 0 12 8"
          width="12"
          height="8"
          aria-hidden="true"
        >
          <path
            d="M 1 1 C 3 3 5 5 6 6.5 C 7 5 9 3 11 1"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}
